import {
  type InfiniteData,
  useInfiniteQuery,
  type UseInfiniteQueryOptions,
} from '@tanstack/react-query';
import type { ListDuosResponse } from 'generated/openapi';

import {
  getDuosKey,
  getDuosOptions,
  type GetDuosQueryKey,
  type GetDuosQueryKeyParams,
} from './getDuos.options';

export interface UseGetDuosProps<T = InfiniteData<ListDuosResponse>> {
  params?: GetDuosQueryKeyParams;
  options?: Omit<
    UseInfiniteQueryOptions<
      ListDuosResponse,
      unknown,
      T,
      GetDuosQueryKey,
      number
    >,
    'queryKey' | 'queryFn' | `${string}PageParam`
  >;
}

export function useGetDuos<T = InfiniteData<ListDuosResponse>>(
  props: UseGetDuosProps<T> = {},
) {
  const { params, options } = props;
  return useInfiniteQuery({
    ...getDuosOptions<T>(params),
    ...options,
  });
}

useGetDuos.getQueryKey = getDuosKey;
